// src/auth/initAuth.ts
import AuthApi from './api/authApi';
import { useAccessTokenStore } from './store/useAccessTokenStore';

const initAuth = async () => {
  try {
    const { accessToken } = await AuthApi.refresh();
    useAccessTokenStore.getState().setToken(accessToken);
  } catch (err) {
    useAccessTokenStore.getState().clear();
  }
};

export default initAuth;
